module.exports = __webpack_public_path__ + "static/vo-fc1a4fcc4ae031be401e42e919a9efc5.mp3";